import type { Cup, DrinkEntry } from "../types/models";

export function resolveEntryVesselKind(entry: DrinkEntry, cupsById?: Map<string, Cup>): string {
  return entry.cup_icon_snapshot ?? (entry.cup_id && cupsById ? cupsById.get(entry.cup_id)?.icon : undefined) ?? "cup";
}

export function preserveEntryVesselSnapshot(updated: DrinkEntry, previous: DrinkEntry): DrinkEntry {
  return {
    ...updated,
    cup_id: updated.cup_id ?? previous.cup_id,
    cup_icon_snapshot: updated.cup_icon_snapshot ?? previous.cup_icon_snapshot ?? null,
    cup_volume_snapshot_ml: updated.cup_volume_snapshot_ml ?? previous.cup_volume_snapshot_ml ?? null
  };
}
